"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'REPLACE';
class ReplaceNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const stringVal = params.inputString || null;
            const search = params.search || null;
            const replacement = params.replacement || '';
            let outputVal = stringVal;
            try {
                if (stringVal && search && (replacement || replacement === '')) {
                    switch (this.config.caseType) {
                        case 'Single Regular Expression':
                            outputVal = stringVal.replace(RegExp(search), replacement);
                            break;
                        case 'All Regular Expression':
                            outputVal = stringVal.replace(RegExp(search, 'g'), replacement);
                            break;
                        case 'Single Basic':
                            outputVal = stringVal.replace(search, replacement);
                            break;
                        case 'All Basic':
                        default:
                            outputVal = stringVal.replace(RegExp(search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), replacement);
                    }
                }
                return { output: outputVal };
            }
            catch (error) {
                console.log('Replace Node', error);
            }
            return { output: undefined };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.ReplaceNode = ReplaceNode;
ReplaceNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Replace',
    isIdempotent: true,
    primaryCategory: 'Text',
};
//# sourceMappingURL=Replace.js.map